import { DefaultPageHeader } from 'layouts';
import { useState } from 'react';
import { usePermissions } from 'permissions';
import { AddLine, Button, Col } from 'ui';
import { VideoCreateModal } from './video-create-modal';
import { VideoList } from './video-list';

type P = {
  getPathToVideoDetail: (id: string) => string;
  onNavigateToVideoDetail: (id: string) => Promise<void>;
};

const Videos = ({ getPathToVideoDetail, onNavigateToVideoDetail }: P) => {
  const [isVideoCreateModalOpened, setIsVideoCreateModalOpened] = useState(false);

  const { canCreateVideo } = usePermissions();

  return (
    <>
      <DefaultPageHeader
        extra={
          canCreateVideo({}) ? (
            <Col>
              <Button
                icon={<AddLine />}
                onClick={() => {
                  setIsVideoCreateModalOpened(true);
                }}
                size="large"
                type="primary"
              >
                Add video
              </Button>
            </Col>
          ) : undefined
        }
        title="Videos"
      />

      <VideoList getPathToVideoDetail={getPathToVideoDetail} />

      <VideoCreateModal
        isOpened={isVideoCreateModalOpened}
        onClose={() => {
          setIsVideoCreateModalOpened(false);
        }}
        onNavigateToVideoDetail={onNavigateToVideoDetail}
      />
    </>
  );
};

export default Videos;
